import { BaseElement, defineElement } from '@webtides/element-js';
import BuyBoxEvents from '../../structures/_buy-box/buy-box/BuyBoxEvents';
import SelectedSpecs from '../../structures/_buy-box/SelectedSpecs';
import qs from 'qs/dist/qs';
import ProductPageEvents from '../../cms-pages/product-page/ProductPageEvents';

class AvailabilityAlertElement extends BaseElement {
    properties() {
        return {
            updateVariantOnChange: false,
        };
    }

    events() {
        return {
            document: {
                ...(this.updateVariantOnChange && {
                    [BuyBoxEvents.VARIANT_CHANGE]: ({ detail: selectedVariant }) => {
                        this.$refs.sku.value = selectedVariant.sku;
                        if (this.$refs.productURL) {
                            this.$refs.productURL.value = this.updateProductUrl(selectedVariant);
                        }
                    },
                    [ProductPageEvents.PRODUCT_COMPLETELY_LOADED]: ({ detail: product }) => {
                        this.$refs.productName.value = product.name;
                    },
                }),
            },
        };
    }

    updateProductUrl(selectedVariant) {
        const specs = new SelectedSpecs(selectedVariant.specCombinationKey);
        const query = qs.stringify(specs.values);
        const url = `${window.location.origin}${window.location.pathname}?${query}`;
        return url;
    }
}

defineElement('availability-alert-element', AvailabilityAlertElement);
